import { QueryFactory } from '@lmt/shared-types';
import { Button } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { DropDownInput } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/dropdown/DropDownInput';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useMemo, useState } from 'react';
import CrossIcon from '@lmt/unicorn-shared/app/icons/cross.svg?react';

import styles from './ChoosePrefix.module.scss';

export const ChoosePrefix = React.forwardRef<
  HTMLDivElement,
  {
    onClose: (prefix: string | null) => void;
  }
>(function ChoosePrefix(props, ref) {
  const prefixes = QueryFactory.MergeFieldPrefixQuery.useGetQuery();
  const [selectedPrefix, setSelectedPrefix] = useState<string | null>(null);
  const i18n = useScopedTranslation('documents.export_merge_field');

  return (
    <div className={styles.wrapper} ref={ref} data-test-id="export-tooltip">
      <div className={styles.closeIcon} onClick={() => props.onClose(null)}>
        <CrossIcon className={styles.crossIcon} />
      </div>
      <div className={styles.title}>{i18n.t('select_prefix_title')}</div>
      <div className={styles.inputWithButtonRow}>
        <DropDownInput
          required
          variant="normal"
          options={prefixes.data?.prefixes ?? []}
          value={selectedPrefix ?? undefined}
          onValueChanged={(prefix: any) => setSelectedPrefix(prefix)}
          testId="prefix"
        />
        <Button
          title={i18n.t('export_button')}
          onClick={() => {
            props.onClose(selectedPrefix);
          }}
        />
      </div>
    </div>
  );
});
